import React from 'react'
import PropTypes from "prop-types"

//Libs
import slugify from 'slugify'

// Gatsby
import { navigate } from 'gatsby'
import Img from 'gatsby-image'

export default function LargeArticle({ article: { title, intro, category, date, author, image } }) {
  return (
    <div onClick={() => navigate(`/blog/${slugify(title)}`)} className="col-span-12 md:col-span-6 mb-20 hover:shadow-lg bg-white cursor-pointer">
      <Img fluid={image.childImageSharp.fluid} className="max-h-1/2-screen" objectFit="cover" />
      <div className="py-0">
        <p className="bg-gray-900 mt-0 py-2 text-center text-white tracking-wide text-sm mb-4">{category.toUpperCase()}</p>
        <div className="col-span-10 px-5">
          <p className="text-gray-900 text-2xl font-bold tracking-wider my-0">{title}</p>
          <div className="text-gray-900">
            <h2 className="text-lg text-gray-700 leading-snug font-thin">{intro}</h2>
            <p className="text-base text-main_color"><span className="font-bold">{author.name}</span>, {date}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

LargeArticle.propTypes = {
  article: PropTypes.shape({
    title: PropTypes.string,
    intro: PropTypes.string,
    category: PropTypes.string,
    date: PropTypes.string,
    author: PropTypes.shape({
      name: PropTypes.string,
      picture: PropTypes.string
    }),
    image: PropTypes.object
  })
}